import React from 'react';
import { useTranslation } from 'react-i18next';
import { REFUND_TYPES } from '@/utility';

const PayeeCategorySelect = ({
  role,
  allowedRefundTypes = [],
  payeeCategory,
  onChange,
  style = {},
}) => {
  const { t } = useTranslation();
  const defaultStyle = {
    padding: '8px 12px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    fontSize: '14px',
    minWidth: '150px',
    backgroundColor: 'white',
    ...style,
  };

  return (
    <select
      id='payee-category'
      style={defaultStyle}
      value={payeeCategory}
      onChange={onChange}>
      <option value=''>{t('payments.payeeCategory.placeholder')}</option>
      {(allowedRefundTypes.includes(REFUND_TYPES.REGULAR) ||
        role === 'admin') && (
        <option value={REFUND_TYPES.REGULAR}>
          {t('payments.payeeCategory.consumerPayment')}
        </option>
      )}
      {(allowedRefundTypes.includes(REFUND_TYPES.INSURANCE) ||
        role === 'admin') && (
        <option value={REFUND_TYPES.INSURANCE}>
          {t('payments.payeeCategory.insurancePayment')}
        </option>
      )}
      {(allowedRefundTypes.includes(REFUND_TYPES.BUSINESS) ||
        role === 'admin') && (
        <option value={REFUND_TYPES.BUSINESS}>
          {t('payments.payeeCategory.businessPayments')}
        </option>
      )}
    </select>
  );
};

export default PayeeCategorySelect;
